/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerExportAnnotationsToExcelMutationResponse, FilesControllerExportAnnotationsToExcelPathParams } from "../../models/filesController/FilesControllerExportAnnotationsToExcel";

function getFilesControllerExportAnnotationsToExcelUrl(id: FilesControllerExportAnnotationsToExcelPathParams["id"]) {
  const res = { method: 'POST', url: `/api/v1/files/${id}/annotations/excel` as const }  
  return res
}

/**
 * @description Generates an Excel file containing all annotations (notes and markups) for the specified file. The Excel file includes page numbers, annotation types, colors, text content, and creator information. Frontend should send annotationTexts map with extracted text from markup annotations. Supports Unicode characters (including emojis) in filenames via RFC 5987 encoding.
 * @summary Export file annotations to Excel
 * {@link /api/v1/files/:id/annotations/excel}
 */
export async function filesControllerExportAnnotationsToExcel(id: FilesControllerExportAnnotationsToExcelPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<FilesControllerExportAnnotationsToExcelMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getFilesControllerExportAnnotationsToExcelUrl(id).url.toString(), ... requestConfig })  
  return res.data
}